import { useScrollReveal } from '@/hooks/useScrollReveal';

const trustLogos = [
  { name: 'ArcticVault Logistics', category: 'Warehouse Partner' },
  { name: 'FrostLine Warehousing', category: 'Warehouse Partner' },
  { name: 'GlacierFleet Transport', category: 'Transport Partner' },
  { name: 'PolarExpress Cold Chain', category: 'Transport Partner' },
  { name: 'The Sapphire Group', category: 'B2B Buyer' },
  { name: 'Grand Meridian Hotels', category: 'B2B Buyer' },
  { name: 'HavenFresh Provisions', category: 'B2B Buyer' },
  { name: 'DailyFreeze Mart', category: 'Retail Partner' },
];

export default function TestimonialsSection() {
  const { ref, revealed } = useScrollReveal();

  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div ref={ref} className={`container-page scroll-reveal ${revealed ? 'revealed' : ''}`}>
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-semibold text-accent-600 uppercase tracking-widest mb-4">
            Trusted Network
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-primary-700 mb-4">
            Trusted Across the Chain
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto">
            From warehouse operators to five-star hotels — India&apos;s cold chain runs on Freshhlock.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {trustLogos.map((logo) => (
            <div
              key={logo.name}
              className="group bg-card-50 border border-card-200 rounded-xl px-5 py-8 flex flex-col items-center justify-center text-center gap-2 transition-all duration-300 cursor-default shadow-sm hover:shadow-md card-animate"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-1 animate-icon-float icon-hover-pop">
                <i className="ri-building-line text-lg"></i>
              </div>
              <span className="font-heading text-sm font-semibold text-primary-700">{logo.name}</span>
              <span className="text-xs text-foreground-400">{logo.category}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}